import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccentInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.041 11.2072C11.2399 11.2072 11.4307 11.2862 11.5713 11.4268C11.712 11.5675 11.791 11.7582 11.791 11.9572V15.7072C11.791 15.9061 11.87 16.0968 12.0107 16.2375C12.1513 16.3781 12.3421 16.4572 12.541 16.4572",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.416 8.95715C12.0373 8.95715 12.541 8.45347 12.541 7.83215C12.541 7.21083 12.0373 6.70715 11.416 6.70715C10.7947 6.70715 10.291 7.21083 10.291 7.83215C10.291 8.45347 10.7947 8.95715 11.416 8.95715Z",
			fill: "currentColor"
		})
	]
});
export default SvgAccentInfo;
